// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n[data-v-4bc3c99a] .form-select.v-text-field--outlined .v-select__selection--comma {\nline-height: 32px !important;\n}\n[data-v-4bc3c99a] .v-autocomplete:not(.v-input--is-disabled).v-select.v-text-field input {\n    font-size: 14px !important;\n}\n[data-v-4bc3c99a] .theme--light.v-input--is-disabled input, .theme--light.v-input--is-disabled textarea[data-v-4bc3c99a] {\n    font-size: 14px !important;\n}\n\n", ""]);
// Exports
module.exports = exports;
